module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.3a1c3d1.woff2";